var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBracketsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4C14.25 3.58579 14.5858 3.25 15 3.25H19C19.4142 3.25 19.75 3.58579 19.75 4V8.68934L22.5303 11.4697C22.8232 11.7626 22.8232 12.2374 22.5303 12.5303L19.75 15.3107V20C19.75 20.4142 19.4142 20.75 19 20.75H15C14.5858 20.75 14.25 20.4142 14.25 20C14.25 19.5858 14.5858 19.25 15 19.25H18.25V15C18.25 14.8011 18.329 14.6103 18.4697 14.4697L20.9393 12L18.4697 9.53033C18.329 9.38968 18.25 9.19891 18.25 9V4.75H15C14.5858 4.75 14.25 4.41421 14.25 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4C4.25 3.58579 4.58579 3.25 5 3.25H9C9.41421 3.25 9.75 3.58579 9.75 4C9.75 4.41421 9.41421 4.75 9 4.75H5.75V9C5.75 9.19891 5.67098 9.38968 5.53033 9.53033L3.06066 12L5.53033 14.4697C5.67098 14.6103 5.75 14.8011 5.75 15V19.25H9C9.41421 19.25 9.75 19.5858 9.75 20C9.75 20.4142 9.41421 20.75 9 20.75H5C4.58579 20.75 4.25 20.4142 4.25 20V15.3107L1.46967 12.5303C1.17678 12.2374 1.17678 11.7626 1.46967 11.4697L4.25 8.68934V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsAlt);
export default __webpack_public_path__ + "static/media/brackets-alt.f324b52afc5f449b6edb18374d328b2f.svg";
export { ForwardRef as ReactComponent };